/* Dear eM v25.4 (Claude, 23/10/2026): nút "Chia sẻ thiết kế" (copy link thiết kế).
   v25.4: link ngắn dearem.co/d/<mã>?d=…&v=… (window.emShortLink trong snippets/em-demo-link.liquid); mở link là vào thẳng bước Xem lại.
   v25.7: nút Chia sẻ sát góc trên bên phải (điện thoại: góc khung xem trước; máy tính: góc hình demo);
          nút "Xem ảnh to / Thu nhỏ" (điện thoại) chỉ còn icon, không chữ.
   - Bước "Xem lại trước khi đặt" (sau khi bấm Tiếp tục): nút nhỏ ở góc trên bên phải hình demo.
   - Dòng tóm tắt "Thiết kế thêu của bạn … Sửa" trên trang sản phẩm: chữ "Chia sẻ thiết kế" cạnh "Sửa".
   Icon SVG (không dùng emoji). Link = reviewUrl() của customizer v6 (?variant=…&dmc=…): mở link là thấy đúng thiết kế.
   Nạp từ cuối snippets/em-customizer-patch.liquid (SP có customizer). */
(function () {
  var IC = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M10 14a4.5 4.5 0 0 0 6.4 0l3-3a4.5 4.5 0 0 0-6.4-6.4l-1.2 1.2"/><path d="M14 10a4.5 4.5 0 0 0-6.4 0l-3 3a4.5 4.5 0 0 0 6.4 6.4l1.2-1.2"/></svg>';
  var OK = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';
  function css() {
    if (document.getElementById('em-share-css')) return;
    var s = document.createElement('style'); s.id = 'em-share-css';
    s.textContent =
      '.em-share-btn,.em-share-fab{display:inline-flex;align-items:center;gap:5px;font:inherit;cursor:pointer;-webkit-tap-highlight-color:transparent}' +
      '.em-share-btn svg,.em-share-fab svg{width:14px;height:14px;flex:0 0 14px;fill:none;stroke:currentColor;stroke-width:2;stroke-linecap:round;stroke-linejoin:round}' +
      '.em-share-btn{background:none;border:0;padding:0;margin-left:10px;font-size:12px;color:#7d61bf;font-weight:600;white-space:nowrap;vertical-align:middle}' +
      '.em-share-btn.is-done{color:#2e8b57}' +
      '.em-share-fab{display:none;position:absolute;z-index:8;height:32px;padding:0 12px;border:0;border-radius:999px;background:rgba(255,255,255,.95);color:#7d61bf;font-size:12px;font-weight:600;box-shadow:0 2px 10px rgba(34,34,34,.14)}' +
      '.dmc-modal.is-confirm .em-share-fab{display:inline-flex}' +
      '.em-share-fab.is-done{color:#2e8b57}' +
      '.em-share-toast{position:fixed;left:50%;bottom:96px;transform:translateX(-50%);background:#2b2238;color:#fff;font-size:13px;padding:10px 16px;border-radius:999px;z-index:2147483000;box-shadow:0 6px 20px rgba(0,0,0,.18);opacity:0;transition:opacity .2s;pointer-events:none;max-width:calc(100vw - 32px);text-align:center}' +
      '.em-share-toast.is-on{opacity:1}' +
      /* v25.7: nút Xem ảnh to / Thu nhỏ ở bước Xem lại (em-tts-fix, điện thoại) — chỉ icon */
      '@media screen and (max-width:749px){html.em-tts .is-confirm .tt-cfzoom{font-size:0!important;gap:0!important;width:32px!important;height:32px!important;padding:0!important;justify-content:center!important}' +
      'html.em-tts .tt-cfzoom svg{width:16px!important;height:16px!important}}';
    document.head.appendChild(s);
  }
  function toast(msg) {
    var t = document.querySelector('.em-share-toast');
    if (!t) { t = document.createElement('div'); t.className = 'em-share-toast'; document.body.appendChild(t); }
    t.textContent = msg; t.classList.add('is-on');
    clearTimeout(t._h); t._h = setTimeout(function () { t.classList.remove('is-on'); }, 2600);
  }
  function copy(text) {
    if (navigator.clipboard && window.isSecureContext) return navigator.clipboard.writeText(text);
    return new Promise(function (ok, bad) {
      var ta = document.createElement('textarea'); ta.value = text; ta.setAttribute('readonly', '');
      ta.style.cssText = 'position:fixed;top:-1000px;opacity:0'; document.body.appendChild(ta);
      ta.select(); ta.setSelectionRange(0, text.length);
      var r = false; try { r = document.execCommand('copy'); } catch (e) {}
      document.body.removeChild(ta); r ? ok() : bad();
    });
  }
  function linkOf(inst, d) {
    var sl = null; try { sl = window.emShortLink && window.emShortLink(inst, d); } catch (e) {}
    if (sl) return sl;
    var u = new URL(inst.reviewUrl(d));
    u.searchParams.set('dm_cf', '1');
    u.searchParams.delete('preview_theme_id');
    return u.toString();
  }
  function makeBtn(inst, cls, label, getD) {
    var b = document.createElement('button');
    b.type = 'button'; b.className = cls; b.setAttribute('aria-label', 'Chia sẻ thiết kế (copy link)');
    var set = function (done) { b.innerHTML = (done ? OK : IC) + '<span>' + (done ? 'Đã copy link' : label) + '</span>'; b.classList.toggle('is-done', done); };
    set(false);
    b.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      var url; try { url = linkOf(inst, getD()); } catch (err) { return; }
      copy(url).then(function () {
        set(true);
        toast('Đã copy link thiết kế — dán gửi bạn bè hoặc gửi shop nhé');
        setTimeout(function () { set(false); }, 2500);
      }, function () {
        if (navigator.share) navigator.share({ title: document.title, url: url }).catch(function () {});
        else window.prompt('Copy link thiết kế:', url);
      });
    });
    return b;
  }
  function addBtn(inst) {
    var m = inst.summaryMeta;
    if (!m || !inst.state || m.querySelector('.em-share-btn')) return;
    m.appendChild(makeBtn(inst, 'em-share-btn', 'Chia sẻ thiết kế', function () { return inst.state; }));
  }
  /* nút góc hình demo: đặt trong .dmc-stage, canh theo góc trên-phải của khung ảnh (.dmc-canvas) */
  function addFab(inst) {
    var cv = inst.canvas, stg = cv && cv.parentNode;
    if (!stg || stg.querySelector('.em-share-fab')) return;
    if (getComputedStyle(stg).position === 'static') stg.style.position = 'relative';
    var b = makeBtn(inst, 'em-share-fab', 'Chia sẻ', function () { return inst.draft; });
    stg.appendChild(b);
    var mob = window.matchMedia('(max-width: 749px)');
    var place = function () {
      if (!inst.modal || !inst.modal.classList.contains('is-confirm')) return;
      /* nút Xem ảnh to (điện thoại): chỉ icon + nhãn cho trình đọc màn hình */
      var z = stg.querySelector('.tt-cfzoom');
      if (z) { var big = inst.modal.classList.contains('tt-cf-big'), lb = big ? 'Thu nhỏ ảnh' : 'Xem ảnh to'; if (z.getAttribute('aria-label') !== lb) { z.setAttribute('aria-label', lb); z.title = lb; } }
      if (mob.matches) { b.style.top = '8px'; b.style.right = '8px'; return; }
      var s = stg.getBoundingClientRect(), c = cv.getBoundingClientRect();
      b.style.top = Math.max(6, c.top - s.top + 6) + 'px';
      b.style.right = Math.max(6, s.right - c.right + 6) + 'px';
    };
    setInterval(place, 300);
  }
  function hook() {
    var r = document.querySelector('[data-dearem-customizer]'), inst = r && r.__dmc;
    if (!inst) return false;
    css();
    var p = Object.getPrototypeOf(inst);
    if (!p.__emShare) {
      var orig = p.renderSummary;
      p.renderSummary = function () { var out = orig.apply(this, arguments); try { addBtn(this); } catch (e) {} return out; };
      p.__emShare = true;
    }
    try { addBtn(inst); } catch (e) {}
    try { addFab(inst); } catch (e) {}
    return true;
  }
  var n = 0;
  (function wait() { if (hook() || ++n > 60) return; setTimeout(wait, 250); })();
})();
